<template>
<svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 70.402 70.402">
  <g id="Group_76" data-name="Group 76" transform="translate(-315.73 -280.287)">
    <circle id="Ellipse_6" data-name="Ellipse 6" cx="35.201" cy="35.201" r="35.201" transform="translate(315.73 280.287)" fill="#fff"/>
    <g id="Group_5" data-name="Group 5" transform="translate(-1133.858)">
      <path id="Path_9" data-name="Path 9" d="M1495.546,324.158a3.291,3.291,0,0,1-.674-2v-5.25a37.248,37.248,0,0,0-2.487-13.415l-4.681-12.138a1.143,1.143,0,0,0-.622-.647,1.121,1.121,0,0,0-.882,0,1.168,1.168,0,0,0-.7,1.2l-.011,12.749a2.6,2.6,0,0,1,3.491-.237,3.354,3.354,0,0,1,1.129,2.735l.18,10.45h-1.243l-.227-10.467a1.853,1.853,0,0,0-.964-1.679,1.7,1.7,0,0,0-1.84.339c-.411.529-.517,1.4-.515,3.337l-.006,15.9a11.394,11.394,0,0,0,2.225,6.752l7.917,7.717,6.889-5.38Z" fill="#1a1818"/>
      <path id="Path_10" data-name="Path 10" d="M1474.034,324.158a3.292,3.292,0,0,0,.675-2v-5.25a37.271,37.271,0,0,1,2.486-13.415l4.682-12.138a1.139,1.139,0,0,1,.621-.647,1.123,1.123,0,0,1,.883,0,1.167,1.167,0,0,1,.7,1.2l.012,12.749a2.6,2.6,0,0,0-3.491-.237,3.355,3.355,0,0,0-1.13,2.735l-.18,10.45h1.243l.227-10.467a1.852,1.852,0,0,1,.965-1.679,1.7,1.7,0,0,1,1.839.339c.411.529.518,1.4.515,3.337l.007,15.9a11.405,11.405,0,0,1-2.225,6.752l-7.918,7.717-6.888-5.38Z" fill="#1a1818"/>
    </g>
  </g>
</svg>
</template>

<script>
export default {
  'name': 'SA_02_02_c',
  'props': {
    'size': {
      type: Number,
      default: 40
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/attributes/SC_02_02_c.vue